import { render } from "./AdvancedSetting.vue?vue&type=template&id=10307299&ts=true"
import script from "./AdvancedSetting.vue?vue&type=script&lang=ts"
export * from "./AdvancedSetting.vue?vue&type=script&lang=ts"

import "./AdvancedSetting.vue?vue&type=style&index=0&id=10307299&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__